var Raven = require('raven-js');
var api = require('../modules/xl_api');

// 客户端版本号
var clientVersion = api.getThunderVersion();
// sentry 上报公钥
var DSN = 'http://388210a632ba4776900a1d196bcba68e@bug.xl9.xunlei.com/2';
// 采样率
// 采样率
// 70 / ((700 / 3) * 10) = 0.03
var sampleRate = {
    info: 0.002,
    warning: 0.008,
    error: 0.02
}

Raven
    .config(DSN, {

        // Sentry 使用对的日志记录器的名字，默认是 javascript
        logger: 'misc.xl9',

        release: VERSION,

        // 这应该是服务器的名字，但是在全部的平台上都没这个信息。想法的，你可以使用一些别的值，比如说 设备编号，用来表示当前客户端在哪里运行。
        serverName: clientVersion,

        // 额外的需要在每一个事件上追加的 tags
        tags: {
            environment: window.env,
            buildtime: new Date(window.timestamp)
        },

        // 与 ignoreUrls 相反. 只捕获来源URL的URL匹配或部分匹配了某个正则表达式的地址传入的事件。
        // 这里的来源URL指 JavaScript文件的URL，当且仅当使用 内联的 <script> 标签时，来源URL是当前页面。
        // tags. 如果不设置这个值，默认是捕获全部可能的异常，并且也无法在服务器端使用这个作为过滤条件。
        // 至于 captureMessage 或者 captureException 的传入参数不是异常的情况，不会受此设置的影响。
        whitelistUrls: [
            /xunlei\.com/,
            /kanimg\.com/
        ],

        // 很多时候，你会遇到你应用之外的异常或一些你完全不关心的异常。ignoreErrors 提供的列表可以过滤掉前面那些异常。
        // 通过字符串和正则表达式匹配，符合 ignoreErrors 条件的日志事件会之间被丢弃而不会发往 Sentry 服务器。
        // 至于 captureMessage 或者 captureException 的传入参数不是异常的情况，不会受此设置的影响。
        ignoreErrors: [

        ],

        // 与 whitelistUrls 相反，类似于 ignoreErrors, 会忽略掉url来源完全匹配或使用正则表达式匹配的脚本。
        ignoreUrls: [
        ],

        // 一组正则表达式的模式，用于指明那些脚本的URL来源是你应用程序的一部分，在服务器端展示调用堆栈时，会收起不符合这个模式的代码对于的调用帧，
        // 这个特性让你比较容易的观测在你的代码和其他代码之间都发生了什么。建议将当前页面的URL，你使用的CDN加入列表。
        includePaths: [
            /https?:\/\/misc\.xl9\.xunlei\.com/
        ],

        // 允许在日志事件发送到 Sentry 之前，修改它。
        dataCallback: function (data) {
            // do something to data
            return data;
        },

        // 数据采样
        // 允许你使用自己的过滤器去判断日志事件是否应该被送到 Sentry 服务器上。

        shouldSendCallback: function (data) {
            return (Math.random() <= sampleRate[data.level]);
            // {
            //     "project": "6",
            //     "logger": "misc.xl9",
            //     "platform": "javascript",
            //     "request": {
            //         "headers": {
            //             "User-Agent": "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_12_0) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/53.0.2785.143 Safari/537.36"
            //         },
            //         "url": "http://home.xl9.xunlei.com/"
            //     },
            //     "message": "game load 540ms",
            //     "level": "info",
            //     "tags": {
            //         "environment": "production",
            //         "buildtime": "2016-10-08T07:27:44.004Z",
            //         "module": "switch_screen_lazy_loader.js"
            //     },
            //     "Extra": {
            //         "args": []
            //     },
            //     "extra": {
            //         "session:duration": 669
            //     },
            //     "breadcrumbs": {
            //         "values": [
            //             {
            //                 "timestamp": 1475911846.166,
            //                 "message": "[object Object]",
            //                 "level": "log",
            //                 "category": "console"
            //             },
            //             {
            //                 "timestamp": 1475911846.169,
            //                 "message": "[object Object]",
            //                 "level": "log",
            //                 "category": "console"
            //             },
            //             {
            //                 "timestamp": 1475911846.508,
            //                 "category": "ui.click",
            //                 "message": "body > div.index"
            //             },
            //             {
            //                 "timestamp": 1475911846.637,
            //                 "category": "ui.click",
            //                 "message": "div#wrap.wrap.w_700.s_w > div.main_tab > div#mainTabGame.main_tab_list"
            //             }
            //         ]
            //     },
            //     "user": {},
            //     "release": "1.4.0",
            //     "server_name": "unknow"
            // }
        },


        // Raven 默认不会截断任何消息，如果你有其他的考虑需要截断消息，可以使用这个设置。
        // maxMessageLength: 1024,

        // 改写默认的 HTTP 协议的数据传输程序。
        // 等价的，你也可以使用 Raven.setTransport(myTransportFunction) 修改默认的的传输程序。
        // transport: function (options) {
        //     // send data
        // },

        // 默认情况下，如果Raven.js被配置了一个包括秘钥的DSN，Raven.js 将抛出一个错误。
        // 你可能需要使用你的包括秘钥的DSN。要做到这一点，设置``allowPrivateKey:true` 。
        // allowSecretKey: false

    })
    .install();

module.exports = Raven;


//////////////////
// WEBPACK FOOTER
// ./static/1.0/js/page/dev/utils/raven.js
// module id = 9
// module chunks = 1 2 3 5 6 7 8 9 10 11 12